"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Heights_1 = __importDefault(require("../entity/FacetParts/Heights"));
const defaultValue = [
    { value: '980', count: 123 },
    { value: '1080', count: 1234 },
    { value: '1200', count: 1234 },
    { value: '1920', count: 1234 },
];
exports.generateHeightEntity = (jsons = defaultValue) => Heights_1.default.fromJSON({
    buckets: jsons,
});
